/**
 * Open an external URL.
 *
 * On iOS Capacitor, `<a target="_blank">` is silently dropped by WKWebView (no popup
 * target → tap is a no-op). Apple's reviewer flagged this under Guideline 3.1.2(c)
 * for the Terms of Use / Privacy Policy links in the subscription paywall.
 *
 * Use this helper instead of relying on target="_blank" for any user-facing legal
 * or external link inside the app.
 */

import { Capacitor } from '@capacitor/core';

function absoluteUrl(href) {
  if (/^https?:\/\//i.test(href)) return href;
  const origin = (typeof window !== 'undefined' && window.location?.origin) || '';
  // Capacitor's WKWebView origin is `capacitor://localhost` — that won't resolve a
  // static .html on the device. Hard-code the public site for relative paths on native.
  if (Capacitor.isNativePlatform()) {
    return `https://streaks.wolftechnologies.co.uk${href.startsWith('/') ? '' : '/'}${href}`;
  }
  return `${origin}${href.startsWith('/') ? '' : '/'}${href}`;
}

export async function openExternal(href) {
  const url = absoluteUrl(href);
  if (Capacitor.isNativePlatform()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
